import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PatientMedicationPage } from './patient-medication';
import { ComponentsModule } from '../../components/components.module';
import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
  declarations: [
    PatientMedicationPage,
  ],
  imports: [
    IonicPageModule.forChild(PatientMedicationPage),
    ComponentsModule,
    DirectivesModule
  ],
})
export class PatientMedicationPageModule {}



// WEBPACK FOOTER //
// ./src/pages/patient-medication/patient-medication.module.ts